export const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
export const range = (start, end) => {
    if (start > end)
        return [];
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rafThrottle = (fn) => {
    let rafId = null;
    let args = null;
    return function (...newArgs) {
        args = newArgs;
        if (rafId === null) {
            rafId = requestAnimationFrame(() => {
                rafId = null;
                fn(...args);
            });
        }
    };
};
